export default __webpack_public_path__ + "static/media/download.b178ae95.gif";